import React, { forwardRef } from 'react';
import { Slide } from '@material-ui/core';
import styled from 'styled-components';
import { makeStyles, createTheme } from '@material-ui/core/styles';
import { orange } from '@material-ui/core/colors';

export const Transition = forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);

export const Button = styled.button`
  width: 150px;
  transition: all 0.5s ease-in-out;
  background-color: #FFA500;
  border: none;
  border-radius: 5px;
  color: white;
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
  font-family: 'Nunito', sans-serif;
  height: 50px;
  letter-spacing: 1px;
  margin: 0 ;
  &:hover {
    background-color: #FFA555;
    border-color: #fff;
  }
}
`;
const styles = {
  filesContainer: {
    width: '250px',
    height: '40px',
    margin: '5px',
    display: 'flex',
    padding: '5px',
    alignItems: 'center',
    borderRadius: '10px',
    justifyContent: 'space-between',
    backgroundColor: '#E4E6EB',
    overflow: 'hidden',
  },
  fileName: {
    fontSize: '14px',
    fontFamily: 'Nunito',
    fontWeight: 'bold',
    textOverflow: 'ellipsis',
    width: '213px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  },
};
export const useStyles = makeStyles(styles);

export const theme = createTheme({
  palette: {
    primary: orange,
  },
});
